module.exports = __webpack_public_path__ + "c446ac598d6c790f62d75409d132bc3f.pdf";